import type { Pinia } from "pinia";
import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin({
  name: "sentry-user-context",
  enforce: "post",
  setup(nuxtApp) {
    if (import.meta.env.STORYBOOK) return;
    const pinia = nuxtApp.$pinia as Pinia | undefined;
    if (!pinia) return;
    const setUserContext = () => {
      const userStore = useUserStore(pinia);

      if (userStore.user) {
        Sentry.setUser({
          id: userStore?.user?.id?.toString() || "N/A",
        });

        Sentry.setTag("user.timezone", userStore.user.timezone);
        Sentry.setTag("user.roles", userStore.user.roles.join(","));
        Sentry.setTag("user.profiles_count", userStore.user.profiles.length.toString());
      } else {
        Sentry.setUser(null);
      }
    };

    nuxtApp.hook("app:mounted", () => {
      setUserContext();
      const userStore = useUserStore(pinia);
      watch(() => userStore.user, setUserContext, { immediate: true });
    });
  },
});
